import DashboardSection from './styles'
export default DashboardSection